<template>
  <div class="company-wall-municipality-card">
    <SCompanyCardSkeleton />

    <div class="company-wall-municipality-card__description">
      <STextSkeleton width="95%" />
      <STextSkeleton width="80%" />
    </div>

    <div class="company-wall-municipality-card__buttons">
      <SButtonSkeleton />
      <SButtonSkeleton />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  SButtonSkeleton,
  SCompanyCardSkeleton,
  STextSkeleton,
} from "@solvari/components";
</script>
